import * as React from "react";

import { UitkFigure } from "uitk-react-images";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkCardAloha, UitkCardAlohaLink, UitkCardAlohaContentSection } from "uitk-react-cards";

import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { AttributionText } from "components/shared/AttributionText/AttributionText";
import { useLocalization } from "@shared-ui/localization-context";
import { DestinationCardProps } from "components/shared/DestinationCardView/typings";
import { UitkSpacing } from "uitk-react-spacing";
import { LazyLoadedImage } from "components/utility/LazyLoadedImage/LazyLoadedImage";

const DestinationCard = (props: DestinationCardProps) => {
  const { name, description, url, thumborizedImage, localiseKey, moduleName } = props;
  const { formatText } = useLocalization();
  const isDescriptionPresent = Boolean(description?.length);

  return (
    <UitkCardAloha>
      <UitkFigure ratio={UitkFigure.AspectRatio.R16_9} className="uitk-card-roundcorner-all">
        <LazyLoadedImage src={thumborizedImage.mediaUrl} alt={thumborizedImage.alt} />
        <AttributionText
          source={thumborizedImage.source}
          origin={thumborizedImage.origin}
          attribUrl={thumborizedImage.attribUrl}
          authorName={thumborizedImage.authorName}
          authorUrl={thumborizedImage.authorUrl}
          licenseSuite={thumborizedImage.licenseSuite}
          licenseName={thumborizedImage.licenseName}
          licenseUrl={thumborizedImage.licenseUrl}
        />
      </UitkFigure>

      <UitkCardAlohaContentSection>
        <UitkHeading level={3} size={400}>
          {name}
        </UitkHeading>

        {isDescriptionPresent && (
          <UitkSpacing margin={{ blockstart: "two" }}>
            <UitkText size={300}>{description?.join("")}</UitkText>
          </UitkSpacing>
        )}
      </UitkCardAlohaContentSection>

      <UitkCardAlohaLink>
        <TrackedLink
          aria-label={formatText(localiseKey, name)}
          data-testid="destinationCardLink"
          moduleName={moduleName}
          rfrr="link-destination"
          href={url}
        />
      </UitkCardAlohaLink>
    </UitkCardAloha>
  );
};

export default DestinationCard;
